import { VehicleList } from "./VehicleList";

export function BusesList() {
  return <VehicleList resource="buses" />;
}
